module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }